<template>
  <router-view />
</template>

<script setup></script>

<style>
#app {
  font-family: PuHuiTiThin;
}
.border-box-right {
  position: relative;
  border-radius: 26px 0 0 26px;
  /* 原始背景效果保持不变 */
  background: radial-gradient(
      42.09% 69.53% at 2.87% 0%,
      rgba(78, 115, 235, 0.3) 0%,
      rgba(78, 115, 235, 0) 100%
    ),
    linear-gradient(90deg, rgba(88, 131, 255, 0.1) 0%, rgba(30, 41, 75, 0) 100%);
}
.border-box-right::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 26px 0 0 26px; /* 保持圆角一致 */
  padding: 1px; /* 边框厚度不变 */
  /* 降低亮度：将65%调整为60%，更接近预期色调 */
  background: linear-gradient(
    90deg,
    hsla(225, 58%, 60%, 1),
    /* 左侧主色（降低亮度） */ hsla(225, 58%, 60%, 0) /* 右侧透明（同步调整） */
  );
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
}
.border-box-top {
  position: relative;
  border-radius: 26px 26px 0 0;
  /* 原始背景效果保持不变 */
  /* 原始背景效果保持不变 */
  background: radial-gradient(
      42.09% 69.53% at 2.87% 0%,
      rgba(78, 115, 235, 0.3) 0%,
      rgba(78, 115, 235, 0) 100%
    ),
    linear-gradient(
      180deg,
      rgba(88, 131, 255, 0.1) 0%,
      rgba(30, 41, 75, 0) 100%
    );
}
.border-box-top::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 26px 26px 0 0; /* 保持圆角一致 */
  padding: 1px; /* 边框厚度不变 */
  /* 降低亮度：将65%调整为60%，更接近预期色调 */
  background: linear-gradient(
    180deg,
    hsla(225, 58%, 60%, 1),
    /* 左侧主色（降低亮度） */ hsla(225, 58%, 60%, 0) /* 右侧透明（同步调整） */
  );
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
}
/* @font-face {
  font-family: "AlibabaPuHuiTi";
  src: url("@/assets/font/Alibaba_PuHuiTi_2.0_35_Thin_35_Thin.ttf")
    format("ttf");
} */
</style>
